import {afterNextRender, Component, DestroyRef, ElementRef, signal, untracked, ViewChild} from '@angular/core'
import {fromEvent} from 'rxjs'
import {takeUntilDestroyed} from '@angular/core/rxjs-interop'
import {NgStyle} from '@angular/common'

@Component({
  templateUrl: './holy-grail-sticky-wrapper.component.html',
  selector: 'cft-holy-grail-sticky-wrapper',
  standalone: true,
  styles: `
    @reference '../../../../styles/app-reference.css';

    :host {
      @apply relative block h-full;
    }
  `,
  imports: [NgStyle],
})
export class HolyGrailStickyWrapperComponent {
  protected readonly fill = signal(0)
  @ViewChild('stickyRef', {read: ElementRef})
  navbar!: ElementRef<HTMLElement>

  private scrollPosition = 0
  protected scrollDirection = signal<'up' | 'down'>('down')
  protected positionOffset = signal(0)

  constructor(private readonly destroyRef: DestroyRef) {
    afterNextRender({
      read: () => {
        const gridLeftColumnElement = document.querySelector('cft-holy-grail-grid-col-left')
        fromEvent(window, 'scroll')
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(_ => {
            const sideNavElement = this.navbar.nativeElement
            const navHeight = sideNavElement.offsetHeight
            const windowHeight = window.innerHeight
            // Calculate the overflowing height of the nav container
            // This gives us the offset for top and bottom positioning
            const navOverflowOffset = windowHeight - navHeight
            const navDocumentOffset = (gridLeftColumnElement?.getBoundingClientRect().top || 0) + window.scrollY
            // correction is the height of the element we add before the sticky element.
            const correction = navDocumentOffset + -navOverflowOffset + 24
            this.positionOffset.set(navOverflowOffset)
            if (this.scrollPosition > window.scrollY && untracked(this.scrollDirection) === 'down') {
              const maxHeightFill =
                gridLeftColumnElement!.getBoundingClientRect().bottom +
                window.scrollY -
                correction -
                window.innerHeight +
                24
              this.scrollDirection.set('up')
              if (window.scrollY >= correction) {
                const fillHeight = Math.min(
                  window.scrollY - correction,
                  // Max height of Fill
                  maxHeightFill,
                )
                this.fill.set(fillHeight)
              }
            } else if (this.scrollPosition <= window.scrollY && untracked(this.scrollDirection) === 'up') {
              const fillHeight = sideNavElement.getBoundingClientRect().top + scrollY - navDocumentOffset
              this.fill.set(Math.max(fillHeight, 0))
              this.scrollDirection.set('down')
            }
            this.scrollPosition = window.scrollY
          })
      },
    })
  }
}
